var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeployed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00156 6.3V5.8C6.00156 5.7 5.90156 5.6 5.80156 5.6H3.10156C2.60156 5.6 2.10156 6 2.10156 6.6V14C2.10156 14.5 2.50156 15 3.10156 15H11.0016C11.5016 15 12.0016 14.6 12.0016 14V2.6L13.2016 3.8C13.3016 3.9 13.5016 3.9 13.6016 3.8L14.0016 3.4C14.1016 3.3 14.1016 3.1 14.0016 3.1L12.1016 1.2C11.8016 1.1 11.6016 1 11.4016 1C11.2016 1 11.0016 1.1 10.9016 1.2L9.00156 3.1C8.90156 3.2 8.90156 3.3 9.00156 3.4L9.40156 3.8C9.50156 3.9 9.70156 3.9 9.80156 3.8L11.0016 2.6V6V14H3.20156V6.5H5.90156C5.90156 6.5 6.00156 6.4 6.00156 6.3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70156 11C7.90156 11 8.00156 10.9 8.00156 10.7V9.4C8.10156 9.2 7.90156 9 7.70156 9H6.40156C6.20156 9 6.10156 9.2 6.10156 9.4V10.7C6.10156 10.9 6.20156 11 6.40156 11H7.70156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeployed);
export default __webpack_public_path__ + "static/media/Deployed.714a453fcb2997dbb8716fab3d71eb55.svg";
export { ForwardRef as ReactComponent };